<template>
    <v-system-bar color="warning" height="40" class="impersonation-bar px-4">
        <v-icon icon="mdi-account-switch" size="20" class="mr-3" />
        <span class="impersonation-bar__who text-truncate">
            Impersonating <strong>{{ session.user?.userName }}</strong>
            <span v-if="!mobile"> &middot; you are {{ session.impersonating?.userName }}</span>
        </span>
        <v-spacer />
        <v-btn variant="outlined" size="small" class="impersonation-bar__stop text-none" :loading="stopping" @click="stop">Stop impersonating</v-btn>
        <v-snackbar v-model="failed" color="error" :timeout="4000">{{ error }}</v-snackbar>
    </v-system-bar>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useDisplay } from "vuetify";
import { errorMessage } from "@/api";
import { useSessionStore } from "@/store/session";
import { stopImpersonating } from "@/utils/impersonation";

const { mobile } = useDisplay();
const session = useSessionStore();
const router = useRouter();
const stopping = ref(false);
const failed = ref(false);
const error = ref("");

async function stop(): Promise<void> {
    stopping.value = true;
    try {
        await stopImpersonating(router);
    } catch (caught) {
        error.value = errorMessage(caught) ?? "Could not stop impersonating.";
        failed.value = true;
    } finally {
        stopping.value = false;
    }
}
</script>

<style lang="scss">
.impersonation-bar {
    font-size: 14px;

    &__who {
        min-width: 0;
    }

    &__stop {
        flex: none;
    }
}
</style>
